import { useLocalSearchParams, useNavigation } from 'expo-router';
import { useLayoutEffect } from 'react';
import { StyleSheet, View } from 'react-native';

import { Program } from '@/api/models/programModels';
import GoBackButton from '@/components/buttons/GoBackButton';
import NotificationButton from '@/components/buttons/NotificationButton';
import AskQuestionForm from '@/components/forms/AskQuestionForm';
import FormWrapper from '@/components/forms/FormWrapper';
import ProgramCard from '@/components/program/ProgramCard';
import Text from '@/components/Text';
import Title from '@/components/Title';
import { SIGN_IN_BUTTON_BOTTOM } from '@/constants/layout';
import { useAuth } from '@/contexts/authContext';
import { formatCurrency } from '@/utils/currencyFormat';
import { i18n } from '@/utils/i18n';

const ProgramDetail = () => {
  const { state: authState } = useAuth();

  const { programId, npoId, npoName, programJson } = useLocalSearchParams<{
    programId: string;
    npoId: string;
    npoName: string;
    programJson: string;
  }>();

  // Hooks
  const navigation = useNavigation<any>();

  // Parse param
  const parseProgram = (): Program | undefined => {
    try {
      return JSON.parse(programJson) as Program;
    } catch (error) {
      console.error(error);
    }
  };

  const program = parseProgram();

  // Navigation
  useLayoutEffect(() => {
    navigation.setOptions({
      headerShown: true,
      headerShadowVisible: false,
      headerBackVisible: false,
      headerTitleAlign: 'center',
      headerTitle: () => <Title label={`${npoName} Programs`} />,
      headerRight: () => <NotificationButton />,
      headerLeft: () => <GoBackButton />
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [navigation]);

  if (program)
    return (
      <FormWrapper horizontalPadding={0}>
        <View style={style.container}>
          <ProgramCard canEdit={false} program={program} />
          <View style={style.informationContainer}>
            <Text style={[style.leadRow, style.blackText]} fontWeight="700">
              {i18n.t('program_detail.annual_budget')}
            </Text>
            <Text style={[style.leadRow, style.blackText]}>
              {program.budget ? formatCurrency(program.budget) : i18n.t('mix.n_a')}
            </Text>
          </View>
          {authState.signUpData?.loginEmail?.npoId !== npoId && <AskQuestionForm npoId={npoId} programId={programId} />}
        </View>
      </FormWrapper>
    );
};

export default ProgramDetail;

const style = StyleSheet.create({
  navTitle: {
    color: 'black',
    fontSize: 20,
    textAlign: 'center',
    overflow: 'hidden'
  },

  container: {
    paddingVertical: 25,
    paddingHorizontal: 18,
    gap: 28
  },

  informationContainer: {
    flexDirection: 'row',
    gap: 15
  },

  leadRow: {
    marginBottom: 10
  },

  blackText: {
    color: 'black'
  },

  btnStyle: {
    marginBottom: SIGN_IN_BUTTON_BOTTOM,
    width: '100%'
  },

  errorText: {
    color: 'red',
    fontSize: 18
  }
});
